// Get references to elements
const playButton = document.getElementById('playButton');
const imageOverlay = document.getElementById('imageOverlay');
const videoPlayer = document.getElementById('videoPlayer');

// Run only if video elements exist
if (playButton && imageOverlay && videoPlayer) {

    // Function to start the video and hide overlay and play button
    function playVideo() {
        imageOverlay.style.display = 'none';
        playButton.style.display = 'none';

        videoPlayer.style.display = 'block';
        videoPlayer.play();
    }

    // Click event on play button
    playButton.addEventListener('click', playVideo);

    // Click event on overlay image
    imageOverlay.addEventListener('click', playVideo);

    // When video ends
    videoPlayer.addEventListener('ended', function () {
        imageOverlay.style.display = 'block';
        playButton.style.display = 'block';
        playButton.style.cursor = 'pointer';

        videoPlayer.currentTime = 0;
        videoPlayer.style.display = 'none';
    });

    // Show play button on pause
    videoPlayer.addEventListener('pause', function () {
        playButton.style.display = 'block';
        playButton.style.cursor = 'pointer';
    });

    // Hide play button on play
    videoPlayer.addEventListener('play', function () {
        playButton.style.display = 'none';
    });
}

// Detect mobile screen size
var isMobileScreen1 = window.matchMedia("(max-width: 768px)");

// Optional: update on resize
window.addEventListener('resize', function () {
    isMobileScreen1 = window.matchMedia("(max-width: 768px)");
});


// Initialize Swiper for Section 1
const swiper1 = new Swiper('.swiper-1', {
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next-1',
        prevEl: '.swiper-button-prev-1',
    },
    speed: 600,
});

// Initialize Swiper for Section 2
const swiper2 = new Swiper('.swiper-2', {
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next-2',
        prevEl: '.swiper-button-prev-2',
    },
         pagination: {
        el: ".swiper-pagination-2",
        clickable: true,
      },

    speed: 600,
});

// Initialize Swiper for Section 3
const swiper3 = new Swiper('.swiper-3', {
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next-3',
        prevEl: '.swiper-button-prev-3',
    },
    speed: 600,
});

  // Initialize Swiper for Section 4
const swiper4 = new Swiper('.swiper-4', {
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next-4',
        prevEl: '.swiper-button-prev-4',
    },
    speed: 600,
});
  // Initialize Swiper for Section 5
const swiper5 = new Swiper('.swiper-5', {
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next-5',
        prevEl: '.swiper-button-prev-5',
    },
    speed: 600,
});

function custom_slide_to(swiper, index) {
    swiper.params.speed = 600; // Set a consistent speed
    swiper.slideToLoop(index);
}
  
// Function to update active class for nav items
function update_active_nav(items, index) {
    items.forEach((item, idx) => {
        item.classList.toggle('active', idx === index);
    });
}

function setup_nav_items_callbacks(items, swiper) {
  items.forEach((item, idx) => {
    item.addEventListener('click', function () {
      custom_slide_to(swiper, idx);
      update_active_nav(items, idx);
      // Only apply scroll behavior for mobile screens and center the clicked item
      if (isMobileScreen1.matches && idx < items.length - 2) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  });
}


function setup_swiper_slide_change_callback(items, swiper) {
  let allowScroll = false;

  // Mark user interaction
  swiper.on('touchStart', () => allowScroll = true);
  swiper.on('click', () => allowScroll = true);
  swiper.on('navigationNext', () => allowScroll = true);
  swiper.on('navigationPrev', () => allowScroll = true);
  swiper.on('paginationClick', () => allowScroll = true);

  // 🔹 Update nav bar immediately on slideChange
  swiper.on('slideChange', function () {
    const index = swiper.realIndex;
    update_active_nav(items, index);
  });

  // 🔹 Scroll mobile nav only after animation ends
  swiper.on('slideChangeTransitionEnd', function () {
    if (!allowScroll || !isMobileScreen1.matches) return;

    const index = swiper.realIndex;
    if (index >= items.length - 1) {
      items[index]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'end'
      });
    } else {
      items[index]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  });
}


  
  const navItems1 = document.querySelectorAll('.swiper-1 .nav-item');  
  const navItems2 = document.querySelectorAll('.swiper-2 .nav-item');
  const navItems3 = document.querySelectorAll('.swiper-3 .nav-item');
  const navItems4 = document.querySelectorAll('.swiper-4 .nav-item');
  const navItems5 = document.querySelectorAll('.swiper-5 .nav-item');
  
  setup_nav_items_callbacks(navItems1, swiper1);
  setup_nav_items_callbacks(navItems2, swiper2);
  setup_nav_items_callbacks(navItems3, swiper3);
  setup_nav_items_callbacks(navItems4, swiper4);
  setup_nav_items_callbacks(navItems5, swiper5);
  
  setup_swiper_slide_change_callback(navItems1, swiper1);
  setup_swiper_slide_change_callback(navItems2, swiper2);
  setup_swiper_slide_change_callback(navItems3, swiper3);
  setup_swiper_slide_change_callback(navItems4, swiper4);
  setup_swiper_slide_change_callback(navItems5, swiper5);
    
/*
swiper3.on('slideChange', function () {
    const currentSlideIndex = swiper3.realIndex;
    updateActiveNav3(currentSlideIndex);
});
*/